import type { ReactNode } from 'react';
import { Box, Drawer } from '@mui/material';
import { SHELL_RADIUS } from './shellGeometry';

type BottomSheetProps = {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
};

/** Mobile bottom sheet: top-rounded drawer with a drag handle. */
export const BottomSheet = ({ open, onClose, children }: BottomSheetProps) => (
  <Drawer
    open={open}
    onClose={onClose}
    anchor="bottom"
    slotProps={{
      paper: {
        sx: {
          borderRadius: `${String(SHELL_RADIUS)}px ${String(SHELL_RADIUS)}px 0 0`,
        },
      },
    }}
  >
    <Box
      aria-hidden
      sx={{
        width: 36,
        height: 4,
        borderRadius: 2,
        bgcolor: 'divider',
        mx: 'auto',
        mt: 1,
      }}
    />
    {children}
  </Drawer>
);
